import {useIntl} from 'react-intl';
import * as React from 'react';
import {useEffect, useRef, useState} from 'react';
import useSWR from "swr";
import {PenaltyPaymentModel, TreeNode} from "../../lib/types/types";
import {TreeTable} from "primereact/treetable";
import {Column} from "primereact/column";
import moment from "moment-timezone";
import {InputText} from "primereact/inputtext";


interface Props {
    clientId: number | null;
    originalInvoices: any;
}

const PenaltyPaymentHistory : React.FC<Props> = props => {
    const {formatMessage: f} = useIntl();
    const didMountRef = useRef(false);
    const [filteredPenaltyPaymentHistory, setFilteredPenaltyPaymentHistory] = useState<TreeNode<PenaltyPaymentModel>[]>();
    const [dateFilter, setDateFilter] = useState<string>("");
   
    
    const {data: penaltyPaymentHistory} = useSWR<TreeNode<PenaltyPaymentModel>[], Error>(props.clientId ? `/invoices/penalties/history/${props.clientId}` : null);

    useEffect(() => {
        if(!didMountRef.current) {
            didMountRef.current = true;
        }
    }, []);


    
    useEffect(() => {
        if(dateFilter === "") setFilteredPenaltyPaymentHistory(penaltyPaymentHistory);
        const newFilteredPenaltyPaymentHistory = penaltyPaymentHistory?.filter(el => {
            const formattedDate = moment(el.data.invoiceId).format("DD-MM-YYYY HH:mm:ss");
            const matchesDate = formattedDate.includes(dateFilter)
            return matchesDate || el.children.some(el => el.data.invoiceId.includes(dateFilter))
        })
        setFilteredPenaltyPaymentHistory(newFilteredPenaltyPaymentHistory);
    }, [dateFilter, penaltyPaymentHistory]);

    

    const getInvoiceIdColumnTemplate = (rowData: TreeNode<PenaltyPaymentModel>) => {
        if(rowData.key.split("-").length === 1) {
            
            return moment.utc(rowData.data.invoiceId).tz("Europe/Sofia").format("DD-MM-YYYY HH:mm:ss");
        }
        else return rowData.data.invoiceId
    }
    

    return <>
        <TreeTable value={filteredPenaltyPaymentHistory} tableStyle={{ maxWidth: '80rem' }}>
            <Column field="invoiceId" header={f({id: "paymentDate"}) + "/" + f({id: "invoiceNumber"})} expander body={getInvoiceIdColumnTemplate} filter filterElement={<InputText value={dateFilter} onChange={(e) => setDateFilter(e.target.value)}/> }/>
            <Column field="amount" header={f({id: "penaltyPaymentAmount"})} filter/>
            <Column field="penaltyBeforePayment" header={f({id: "penaltyBeforePayment"})} body={(rowData: TreeNode<PenaltyPaymentModel>) => rowData.data.penaltyBeforePayment || "-"} filter/>
            <Column field="penaltyAfterPayment" header={f({id: "penaltyAfterPayment"})} body={(rowData: TreeNode<PenaltyPaymentModel>) => rowData.data.penaltyAfterPayment || "-"} filter/>
            <Column field="note" header={f({id: "note"})} filter/>
        </TreeTable>
    </>
};

export default PenaltyPaymentHistory
